
import Typography from '@/ui-kit/components/typography';
import { TypographyProperty, TypographyType } from '@/ui-kit/components/typography/enums';
import BaseImage from '@/ui-kit/components/image';
import { ImageProperty } from '@/ui-kit/components/image/enums';
import Button from '@/ui-kit/components/button';
import { ButtonProperty, ButtonFillType } from '@/ui-kit/components/button/enums';
import { StyleColorSchemeType, StyleFontWeightType, StyleSizeType } from '@/ui-kit/styles/enums';
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';
import WindowSize from '@/ui-kit/mixins/windowSize';
import ModalService from '@/ui-kit/components/modal/ModalService';
import HowItWorksBuilderModal from '@/components/page-specific/how-it-works/builder-modal/HowItWorksBuilderModal';
import ZohoCustomDeskTicketService from '@/services/api/zoho-custom-desk-ticket';
import { ZohoCustomDeskTicketType } from '@/enums/zoho';
import routes from '@/constants/routes';
import ToastService from '@/components/toast/toast-service';
import { ToastMessage } from '@/ui-kit/components/toast/enums';

export default {
  name: 'InfoBox',
  components: {
    Typography,
    Button,
    BaseImage,
  },
  mixins: [WindowSize],
  props: {
    colorScheme: {
      type: String,
      required: true,
    },
    hero: {
      type: Object,
      default: () => ({}),
    },
    trackEvent: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      TypographyProperty,
      TypographyType,
      StyleColorSchemeType,
      StyleFontWeightType,
      StyleSizeType,
      ButtonProperty,
      ButtonFillType,
      ImageProperty,
    };
  },
  computed: {
    infoBoxClassNames() {
      return new StyleClassNamesBuilder('info-box')
        .addConditionClassNames(Object.values(StyleColorSchemeType), this.colorScheme)
        .build();
    },
    buttonFillType() {
      return this.isSmallerThan(StyleSizeType.Large)
        ? ButtonFillType.Underlined
        : ButtonFillType.Text;
    },
    isBuilderPage() {
      const { path } = this.$route;

      return path === routes.howItWorksBuilder;
    },
  },
  methods: {
    async openBuilderFormModal() {
      const builderFormData = await ModalService.open({
        component: HowItWorksBuilderModal,
      });

      if (!builderFormData) {
        return;
      }

      await this.handleZohoTicketCreation(builderFormData);
    },
    async handleZohoTicketCreation(data) {
      const ticketData = {
        type: ZohoCustomDeskTicketType.HowItWorksBuilder,
        ticketData: data,
      };

      try {
        await ZohoCustomDeskTicketService.createDeskTicket(ticketData);

        ToastService.openPositive(ToastMessage.HowItWorksBuilderFormSuccess);
      } catch (error) {
        ToastService.openNegative(ToastMessage.HowItWorksBuilderFormFail);
      }
    },
  },
};
